const ABProcessCore = require("../core/ABProcessCore");
module.exports = class ABProcess extends ABProcessCore {};
